import { reactive } from 'vue'
import getters from '@/store/license/getters'
import actions from '@/store/license/actions'
import state from '@/store/license/state'

export const licenseModule = {
    state: reactive(state),
    getters,
    actions,
}
